<template>
    <v-container id="docForm" class="max-width">
        <!-- first card -->
        <v-card>
            <v-toolbar dense flat color="secondary">
                <v-toolbar-title>Device IMEI</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn small text to="/goods-receipt">
                    <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>


            <v-card-text>
                <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" md="4">
                        <span class="style-16" style="font-weight: bold">Order Details</span>
                        <br />
                        <span>Supplier: {{ invoiceData.Supplier && invoiceData.Supplier.Name }}</span>
                        <br />

                        <span>Total Invoice Amount: {{ invoiceData.DocTotal | currency }}</span>
                    </v-col>


                    <v-col cols="12" md="4">
                        <span>Total Imeis: {{ imeiRetailsRecord.totalInvoiceImeis }}</span>
                        <br />

                        <span>Imeis Added: {{ imeiRetailsRecord.totalImeisAdded }}</span>
                        <br />
                        <div>Remaining Imeis: <span style="color: red">{{ imeiRetailsRecord.remainingImeis }}</span>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-row class="justify-end">
                            <v-col cols="12" md="7">
                                <span>Invoice Date: {{ invoiceData.CreatedAt | date }}</span>
                                <br>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="4">
                        <span style="color: red; font-size: 20px;">{{ productName }} </span>
                    </v-col>

                    <v-col cols="12" md="8">
                        <v-btn class="float-right" color="primary" text @click.native="imeiDialog = true">
                            View Already Added Imeis <v-icon right dark>mdi-eye</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- end of first card -->

        <v-card class="mt-4">
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field label="Imei Number" @keyup.enter="addImei" outlined dense
                            v-model="imeiNumber"></v-text-field>
                    </v-col>

                    <v-col cols="3">
                        <v-btn color="primary" @click="saveImei" :loading="loader">SAVE IMEI</v-btn>
                    </v-col>

                    <v-col cols="3">
                        <span style="color: red; font-size: 20px">Counter: {{ newImeis.length }}</span>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- no bp card -->
        <v-card class="mt-4">
            <v-card-text>
                <v-row dense class="subtitle-2 text--primary">
                    <v-col cols="8">
                        <v-data-table light dense :items-per-page="1000" :headers="headers" :items="newImeis"
                            :mobile-breakpoint="0">

                            <!-- action template -->
                            <template v-slot:item.delete="{ item }">
                                <v-btn @click="deleteImei(item)" color="red" icon>
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <!-- end -->
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- end of card -->

        <!-- product quick add dialog -->
        <v-dialog v-model="imeiDialog" max-width="650px">
            <v-card>
                <v-toolbar dense color="primary" dark>
                    <v-toolbar-title>IMEI LIST</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="imeiDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row justify="center">
                            <v-col cols="12">
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                    hide-details></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-data-table light dense :items-per-page="100" :headers="imeiHeaders"
                                    :items="imeiRecords" item-key="id" :mobile-breakpoint="0" :search="search">
                                    <template v-slot:item.status="{ item }">
                                        <span v-if="item.soldStatus == 1" style="color: red; font-weight: bold;">
                                            Sold
                                        </span>
                                         <span v-if="item.soldStatus != 1" style="color: green; font-weight: bold;">
                                            In Stock
                                        </span>
                                    </template>

                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- end of modal-->


        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
export default {
    props: {
        docTitle: {
            type: String
        },
        backUrl: {
            type: String
        },
        noTitle: {
            type: String
        },
    },
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        },
    },
    data: () => ({
        imeiDialog: false,
        search: "",
        imeiHeaders: [
            { text: "Product", value: "product.Name" },
            { text: "Imei", value: "imei" },
            { text: "Status", value: "status" }
        ],
        imeiNumber: "",
        newImeis: [],
        record: {},
        productName: "",
        productId: null,
        imeiRetailsRecord: {},
        editingDialog: false,
        editItem: {},
        DocNum: null,
        loader: false,
        copyObj: null,
        invoiceData: {},
        imeiRecords: [],
        copyData: [{ Name: "Goods Receipt", id: 12 }],
        orderItems: [],
        accounts: [],
        pageItems: 100,
        headers: [
            { text: "IMEI", value: "imei" },
            { text: "Action", value: "delete" },
        ],
        paymentHeaders: [
            { text: "Account", value: "Name" },
            { text: "Amount", value: "SumApplied" },
            { text: "Ref/Code", value: "PaymentRemarks" }
        ]
    }),
    watch: {
        "$route.params.id": {
            handler: "getById",
            immediate: true,
        },
    },
    methods: {
        deleteImei(imei) {
            var pos = this.newImeis.indexOf(imei);

            if (pos === -1) {
                return;
            }

            this.newImeis.splice(pos, 1);
        },
        addImei() {
            if (this.imeiNumber == "") {
                this.$refs.snackbar.show("Please enter IMEI number", "red");
                return;
            }

            // check if imei already exists
            const existing = this.newImeis.find(item => item.imei === this.imeiNumber);
            if (existing) {
                this.imeiNumber = "";
                this.$refs.snackbar.show("This IMEI number already exists", "red");
                return;
            }

            // add new imei
            this.newImeis.push({
                imei: this.imeiNumber
            });

            // clear input
            this.imeiNumber = "";
        },
        saveImei() {
            if (this.newImeis.length <= 0) {
                this.$refs.snackbar.show("Please add at least one IMEI", "red");
                return;
            }

            var subscriberId = localStorage.getItem("subscriber_id");

            var imeiStrings = [];
            this.newImeis.forEach(item => {
                imeiStrings.push(item.imei);
            });


            var data = {
                purchaseId: parseInt(this.invoiceData.id),
                purchaseRowId: parseInt(this.$route.params.id),
                productId: parseInt(this.productId),
                imeiRecords: imeiStrings,
                StoreId: parseInt(this.activeStore),
                subscriberId: parseInt(subscriberId),
            };

            const url = "/save-device-imeis";
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.newImeis = [];
                        self.$refs.snackbar.show("IMEI numbers saved successfully", "green");
                        self.getById(self.$route.params.id);
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getById(val) {
            const self = this;
            // get record
            this.$store
                .dispatch("get", `/device-imeis/${val}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.invoiceData = res.ResponseData.purchase;
                        self.productName = res.ResponseData.productName;
                        self.productId = res.ResponseData.productId;
                        self.imeiRetailsRecord = res.ResponseData;
                        self.imeiRecords = res.ResponseData.imeiRecords;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        }
    },
    created() {

    }
};
</script>

<style lang="scss" scoped>
.genFont {
    font-size: 1.3em;
    font-weight: 500;
}
</style>